export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65')
];

export const server_loads = [];

export const dictionary = {
		"/": [5],
		"/about": [18,[3]],
		"/about/vibes": [19,[3]],
		"/about/whats-new": [20,[3]],
		"/admin": [21,[4]],
		"/admin/about": [22,[4]],
		"/admin/apps/[id]/migrate": [23,[4]],
		"/admin/audit": [24,[4]],
		"/admin/cohort-access": [25,[4]],
		"/admin/guest-access": [26,[4]],
		"/admin/llm-aliases": [27,[4]],
		"/admin/llm-budgets": [28,[4]],
		"/admin/llm-gateway": [29,[4]],
		"/admin/llm-models": [30,[4]],
		"/admin/llm-usage": [31,[4]],
		"/admin/logs": [32,[4]],
		"/admin/namespaces/new": [33,[4]],
		"/admin/org": [34,[4]],
		"/admin/platform-admins": [35,[4]],
		"/admin/preview-users": [36,[4]],
		"/admin/reconciliation": [37,[4]],
		"/admin/reconciliation/[run_id]": [38,[4]],
		"/admin/sharing": [39,[4]],
		"/admin/storage": [40,[4]],
		"/admin/users": [41,[4]],
		"/admin/users/[id]": [42,[4]],
		"/admin/virtual-groups": [43,[4]],
		"/api-docs": [44],
		"/auth/login": [45],
		"/a/[id]": [6,[2]],
		"/a/[id]/audit": [7,[2]],
		"/a/[id]/deploys": [8,[2]],
		"/a/[id]/deploys/new": [10,[2]],
		"/a/[id]/deploys/[deployId]/files": [9,[2]],
		"/a/[id]/errors": [11,[2]],
		"/a/[id]/llm-usage": [12,[2]],
		"/a/[id]/logs": [13,[2]],
		"/a/[id]/settings": [14,[2]],
		"/a/[id]/share": [15,[2]],
		"/a/[id]/storage": [16,[2]],
		"/a/[id]/tokens": [17,[2]],
		"/groups": [46],
		"/groups/new": [48],
		"/groups/[id]": [47],
		"/install": [49],
		"/n/[stub]": [50],
		"/n/[stub]/new": [51],
		"/n/[stub]/settings": [52],
		"/r/[request_id]": [53],
		"/settings/llm": [54],
		"/settings/mcp": [55],
		"/settings/mcp/authorize/[req_id]": [56],
		"/settings/mcp/clients": [57],
		"/settings/mcp/confirm-team-deploy/[req_id]": [58],
		"/settings/metrics": [59],
		"/settings/tokens": [60],
		"/settings/tokens/cli-approve/[req_id]": [61],
		"/settings/tokens/cli-authorize/[req_id]": [62],
		"/settings/usage": [63],
		"/users": [64],
		"/users/[id]": [65]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';